import { Grid, Typography } from "@material-ui/core";
import type { Navigation } from "../../models/navigation";
import { Header } from "../../shared/components/header";
import { AddHighlight } from "../components/add-highlight";
import { Highlights } from "../components/highlights";
import { useStyles } from "./highlights.styles";

type Props = {
  navigation: Navigation[];
};

export const HighlightsContainer = ({ navigation }: Props) => {
  const classes = useStyles();

  return (
    <Header navigation={navigation}>
      <Grid container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <Typography
            variant="h2"
            color="textPrimary"
            component="h1"
            className={classes.sectionTitle}
            data-testid="highlightsContainerTitle"
          >
            Highlights
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Highlights />
        </Grid>
        <Grid item xs={12} md={4}>
          <AddHighlight />
        </Grid>
      </Grid>
    </Header>
  );
};
